import { QuickstartOperation } from "./QuickstartOperation";
import { WizardOperation } from "./WizardOperation";

export type CreateFreewallType = QuickstartOperation | WizardOperation;

export const CreateFreewallType = {
  ...QuickstartOperation,
  ...WizardOperation
};
